import { render, staticRenderFns } from "./supplierContractHistoryDetail.vue?vue&type=template&id=0b013200"
import script from "./supplierContractHistoryDetail.vue?vue&type=script&lang=js"
export * from "./supplierContractHistoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports